// extracted by mini-css-extract-plugin
export var formContainer = "_km-0";
export var message = "_km-1";